import React, { useEffect, useState } from 'react';
import { map } from "lodash";
import Loader from "../../../../../../images/icons/loader.gif";

const PropsToggle = ({ attrName, prefix, options, labelClass, currentValue, onChange }) => {
  const [ val, setVal ] = useState(currentValue);
  const [ isLoading, setIsLoading ] = useState(false);
  useEffect(() => {
    if (currentValue) {
      setIsLoading(false);
      setVal(currentValue);
    }
  }, [ currentValue ]);

  const onChangeMode = (value) => {
    setIsLoading(true);
    onChange(attrName, value);
  };

  return (
    <div className="radio-tabs -grow -block">
      {
        !isLoading &&
        map(options, (option, index) => (
          <label htmlFor={ `${prefix}-${option}` } className={ `radio-tabs_item ${labelClass}` } key={ `${option}-${index}` }>
            <input
              className="fixed"
              id={ `${prefix}-${option}` }
              name={ `${prefix}-${option}` }
              checked={ val === option }
              onChange={ () => {
                onChangeMode(option);
              }
              }
              type="radio"
            />
            <span className="radio-tabs_label -width-1-1 -centered">
              <span>{option}</span>
            </span>
          </label>
        ))
      }
      {
        isLoading &&
        <div className="concept-tags_loader">
          <img width="24px" height="24px" src={ Loader } />
        </div>
      }
    </div>
  );
};

export default PropsToggle;
